// extracted by mini-css-extract-plugin
export var isPrintedCell = "_ye-1";
export var printerIcon = "_ye-0";